import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import * as common from '../common'

export interface Pulse {
  teamSpirit: Pulse.TeamSpirit
  teamMembersOverview: readonly Pulse.TeamMemberOverview[]
  engagementBreakdown: Pulse.EngagementBreakdown
}
export namespace Pulse {
  export const isPulse: TypeChecker<Pulse> = TypeChecker.Factory.lazy(() =>
    TypeChecker.Factory.object<Pulse>({
      engagementBreakdown: EngagementBreakdown.isEngagementBreakdown,
      teamMembersOverview: TypeChecker.Factory.list(
        TeamMemberOverview.isTeamMemberOverview,
      ),
      teamSpirit: TeamSpirit.isTeamSpirit,
    }),
  )
  export const assertIsPulse: TypeAsserter<Pulse> =
    TypeAsserter.Factory.from(isPulse)
  export interface TeamSpirit extends common.Described {
    overallMood: string
  }
  export namespace TeamSpirit {
    export const isTeamSpirit: TypeChecker<TeamSpirit> =
      TypeChecker.Factory.intersection(
        common.Described.isDescribed,
        TypeChecker.Factory.object<Difference<TeamSpirit, common.Described>>({
          overallMood: TypeChecker.isString,
        }),
      )
    export const assertIsTeamSpirit: TypeAsserter<TeamSpirit> =
      TypeAsserter.Factory.from(isTeamSpirit)
  }
  export interface TeamMemberOverview extends common.Named {
    highlight: string
    concern: string
  }
  export namespace TeamMemberOverview {
    export const isTeamMemberOverview: TypeChecker<TeamMemberOverview> =
      TypeChecker.Factory.intersection(
        common.Named.isNamed,
        TypeChecker.Factory.object<
          Difference<TeamMemberOverview, common.Named>
        >({
          concern: TypeChecker.isString,
          highlight: TypeChecker.isString,
        }),
      )
    export const assertIsTeamMemberOverview: TypeAsserter<TeamMemberOverview> =
      TypeAsserter.Factory.from(isTeamMemberOverview)
  }
  export interface EngagementBreakdown {
    thriving: number
    engaged: number
    atRisk: number
    disengaged: number
    summary: string
  }
  export namespace EngagementBreakdown {
    export const isEngagementBreakdown: TypeChecker<EngagementBreakdown> =
      TypeChecker.Factory.object<EngagementBreakdown>({
        atRisk: TypeChecker.isNumber,
        disengaged: TypeChecker.isNumber,
        engaged: TypeChecker.isNumber,
        summary: TypeChecker.isString,
        thriving: TypeChecker.isNumber,
      })
    export const assertIsEngagementBreakdown: TypeAsserter<EngagementBreakdown> =
      TypeAsserter.Factory.from(isEngagementBreakdown)
  }

  // TODO Remove this if it isn't used
  export interface Highlight extends common.Named, common.Described {
    // relevantCheckIns: readonly CheckIn.Response[]
  }
  // TODO Remove this if it isn't used
  export namespace Highlight {
    export interface Group extends common.Named, common.Described.Optionally {
      highlights: readonly Highlight[]
    }
  }
}
